export const REDBOT_ISSUES = ["Transaction Not Found", "Folio Not Found", "Client Not Found"];
export const REGISTRARS = ["CAMS", "KARVY"];

export const shuffleArray = (array) => {
  const newArray = array.slice();
  for (let i = newArray.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    const t = newArray[i];
    newArray[i] = newArray[j];
    newArray[j] = t;
  }
  return newArray;
};

export const generateNewUserId = (userIdRef) => {
  const newId = `user_${Math.random().toString(36).slice(2, 11)}`;
  userIdRef.current = newId;
};

export const calculateDateDifference = (dateString) => {
  const fromDate = new Date(dateString);
  const today = new Date();
  const differenceInTime = today.getTime() - fromDate.getTime();
  const differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24));
  return differenceInDays;
};